export const SET_SEARCH_RESULT_BASEPATH = Symbol('SET_SEARCH_RESULT_BASEPATH');
export const CLEAR_SEARCH_RESULT_BASEPATH = Symbol('CLEAR_SEARCH_RESULT_BASEPATH');

export function setSearchResultsBasePath(fromBasePath: string) {
  return {
    type: SET_SEARCH_RESULT_BASEPATH,
    fromBasePath: fromBasePath,
  };
}

export function clearResultsBasePath() {
  return {
    type: CLEAR_SEARCH_RESULT_BASEPATH,
    fromBasePath: '',
  };
}
